import Vue from 'vue';

// Automatic global registration of components

// 1. The relative path of the folder to be automatically required (only)
// 2. Should webpack look in subfolders?
// 3. The regular expression used to match filenames
const requireComponent = require.context(
  '.', // 1.
  false, // 2,
  /[A-Z]\w+\.(vue|js)$/ // 3.
);

// Array to store the names of the registered components
const registeredComponents = [];

// 1. Get component config from path
// 2. Remove './' from the start
// 3. Remove extension from the end
// 4. Register component globally
// 5. Look for the component options on `.default`, which will
// exist if the component was exported with `export default`,
// otherwise fall back to module's root.
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName); // 1.
  const componentName = fileName
    .split('/') // 2.
    .pop() // 2.
    .replace(/\.\w+$/, ''); // 3.
  // Check if component is already registered before registering
  if (!Vue.options.components[componentName]) {
    Vue.component(
      componentName, // 4.
      componentConfig.default || componentConfig // 5.
    );
  }
   // Add the component name to the registeredComponents array
   registeredComponents.push(componentName);
});

export function getGlobalRegisteredComponents() {
  return registeredComponents;
}